import { useQuery } from "@tanstack/react-query";
import type { GetLineItemTranslationsResponseDto } from "../generated/schema";
import { getPublicAuthHeader, getReturnWidgetFetchClient } from "./return-widget-client";

export type LineItemTranslationsResponse = GetLineItemTranslationsResponseDto;

export type LineItemTranslationsParams = {
  providerId: string;
  productIds: string[];
  locale: string;
};

/**
 * Product and variant translations of an order's articles in one locale.
 * Pass `null` to skip the request.
 */
export function usePublicLineItemTranslations(
  params: LineItemTranslationsParams | null,
) {
  const productIds = [...(params?.productIds ?? [])].sort();

  return useQuery({
    queryKey: [
      "line-item-translations",
      params?.providerId ?? "",
      params?.locale ?? "",
      productIds.join(","),
    ],
    queryFn: async () => {
      if (!params) throw new Error("Missing params for line-item-translations");
      const { data, error } = await getReturnWidgetFetchClient().GET(
        "/public/orders/line-item-translations",
        {
          params: {
            query: {
              providerId: params.providerId,
              productIds: productIds.join(","),
              locale: params.locale,
            },
            header: getPublicAuthHeader(),
          },
        },
      );
      if (error) throw error;
      return data as LineItemTranslationsResponse;
    },
    enabled: !!params && productIds.length > 0,
    // Catalog translations do not change during a return.
    staleTime: Infinity,
    retry: 1,
  });
}
